import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookSegmentedControlWrapper } from 'src/components/CookbookSegmentedControlWrapper/CookbookSegmentedControlWrapper';
import {
  FulfillmentType,
  IMealCreditFormFields,
} from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import {
  fulfillmentTypeOptions,
  FulfillmentTypeSegmentedValues,
} from 'src/components/oneCorp/features/MealCredit/common/formFields/mealCreditFormFields.utils';

export interface FulfillmentTypeSegmentedControlProps {
  name: string;
  id: string;
}

export function FulfillmentTypeSegmentedControl({
  name,
  id,
}: FulfillmentTypeSegmentedControlProps): JSX.Element {
  const { control } = useFormContext<IMealCreditFormFields>();

  const valueToFormStateTransformer = (
    type: FulfillmentTypeSegmentedValues
  ) => {
    if (type === FulfillmentTypeSegmentedValues.ALL) {
      return [FulfillmentType.DELIVERY, FulfillmentType.PICKUP];
    }
    return [type];
  };

  const formStateToValueTransformer = (value: FulfillmentType[]) => {
    if (!Array.isArray(value)) {
      return value;
    }

    const expectedValues = Object.values(FulfillmentType);

    if (
      value.length > 1 &&
      value.every((val) => expectedValues.includes(val))
    ) {
      return FulfillmentTypeSegmentedValues.ALL;
    }

    return value[0];
  };

  return (
    <CookbookSegmentedControlWrapper
      id={id}
      width="100%"
      control={control}
      label="Order methods"
      name={name}
      defaultValue={[FulfillmentType.DELIVERY, FulfillmentType.PICKUP]}
      options={fulfillmentTypeOptions}
      valueToFormStateTransformer={valueToFormStateTransformer}
      formStateToValueTransformer={formStateToValueTransformer}
    />
  );
}
